<template>
    <div>
     <b-modal 
         v-model="this.open" 
         stacking
         centered
         no-close-on-esc
         no-close-on-backdrop
         hide-footer
         size="lg"
         @hidden="closeModal()"
     >
         <template slot="modal-title" class="border-0 ">
             <div slot="header" class="text-center">
                 <h1 v-bind:style="{ color: this.$THEME.backgroundColor, fontWeight: 'bold' }">ยืนยันข้อมูลเปิดใช้งาน Wallet</h1>
             </div>
         </template>
         <div>
             <div v-if="this.isOldCustomer" class="mb-4">
                 <p class="text-sm m-0" v-bind:style="{ textIndent: '20px' }">
                     โปรดยืนยันตัวตนของท่านเพื่อเปิดใช้งานระบบ Wallet เนื่องจากระบบจะปรับการใช้งานส่วนการชำระเงิน จากการออกใบแจ้งหนี้ เป็นระบบ Wallet
                 </p>
                 <p class="text-sm m-0" v-bind:style="{ textIndent: '20px' }">
                     กรุณายืนยันข้อมูลเพื่อเปิดใช้งานระบบ Wallet ก่อนวันที่ {{ this.formattedDate }} หากไม่ยืนยันจะส่งผลให้ท่านไม่สามารถใช้งานระบบต่อได้ <span v-if="this.role.member" class="text-red text-decoration-underline">&nbsp;โปรดแจ้งเจ้าของร้านเพื่อดำเนินการตามวิธีด้านล่าง</span>
                 </p>
             </div>
 
             <div v-if="!this.isOldCustomer" class="mb-4">
                 <p class="text-sm m-0" v-bind:style="{ textIndent: '20px' }">
                     กรุณาดำเนินการยืนยันตัวตนเพื่อเปิดใช้ Wallet ก่อนการใช้งาน โดยระบบจะส่งลิงก์ไปที่ Email ด้านล่าง <span v-if="this.role.member" class="text-red text-decoration-underline">&nbsp;โปรดแจ้งเจ้าของร้านเพื่อดำเนินการตามวิธีด้านล่าง</span>
                 </p>
             </div>
 
             <p class="text-sm m-0">1. กดปุ่มยืนยันเพื่อรับลิงก์ยืนยันตัวตนผ่านอีเมล</p>
             <p class="text-sm m-0">2. กดลิงก์ในอีเมลที่ระบบส่งให้</p>
             <p class="text-sm m-0">3. ตรวจสอบและยืนยันข้อมูลตามที่ระบบ</p>
             <p class="text-sm m-0">4. เมื่อยืนยันการเปิดใช้งานสำเร็จแล้ว ดำเนินการเติมเงินและใช้งานได้ทันที</p>
 
             <div class="d-flex flex-column justify-content-center align-items-center mt-4">
                 <div class="form-group w-75">
                     <label>Email</label>
                     <input type="email" class="form-control" :disabled="true" v-model="this.email">
                 </div>
                 <b-button v-if="this.role.admin" size="sm" class="w-25" block variant="primary" @click="handleSubmitVerification" v-bind:disabled="this.loading">ยืนยัน</b-button>
             </div>
             <div v-if="this.message" class="text-center mt-2" v-bind:style="{ color: this.isSuccess ? 'green' : 'red'  }">{{ this.message }}</div>
         </div>
     </b-modal>
    </div>
 </template>
 
 <script>
     import lsm from '@/constants/LocalStorageManagement'
     import moment from 'moment'
     import { fetchShopMetadataToLocalStorage } from '@/axios/walletPayment'
 
     export default {
         name: 'VerifyWalletModal',
         data() {
             return {
                 email: '',
                 open: false,
                 message: '',
                 isSuccess: false,
                 isOldCustomer: false,
                 formattedDate: '',
                 loading: false,
                 role: {
                     admin: false,
                     member: false
                 }
             }
         },
         methods: {
             closeModal() {
                 this.open = false
                 this.email = ''
             },
             getShopMetadata() {
                 const shopMetaData = lsm.shopMetadata().get()
 
                 const createdAt = shopMetaData.shop_metadata ? shopMetaData.shop_metadata.created_at : null
                 const launchedAt = shopMetaData.shop_metadata ? shopMetaData.shop_metadata.walletv2_launched_date : null
 
                 return { createdAt, launchedAt }
             },
             handleShouldOpen(values) {
                 this.email = values.email
                 this.isOldCustomer = values.isOldCustomer
                 this.formattedDate = values.formattedDate
                 this.open = true
             },
             openModal() {
                 const allowThemes = ['shippop']
 
                 if (!process.env.VUE_APP_MEMBER_SERVICE_API || !allowThemes.includes(this.$THEME.name)) {
                     return null
                 }
 
                 moment.locale('th')
                 
                 const walletMetaData = lsm.walletMetadata().get()
                 
                 const email = walletMetaData.wallet_metadata ? walletMetaData.wallet_metadata.email : ''
                 const verifed = walletMetaData.wallet_metadata ? walletMetaData.wallet_metadata.verified : 0
                 const enabled = walletMetaData.wallet_metadata ? walletMetaData.wallet_metadata.enabled : 0
                 const isAdmin = this.$USER_LOGIN.get().isAdmin
                 const isMember = this.$USER_LOGIN.get().isMember
 
                 const shouldOpen = (isAdmin || isMember) && email && !verifed && enabled
 
                 this.role.admin = isAdmin
                 this.role.member = isMember
 
                 if (shouldOpen) {
                     const shopMetadata = this.getShopMetadata()
 
                     if (!shopMetadata.createdAt || !shopMetadata.launchedAt) {
                         fetchShopMetadataToLocalStorage().then(() => {
                             const { createdAt, launchedAt } = this.getShopMetadata()
 
                             this.handleShouldOpen({ 
                                 email, 
                                 isOldCustomer: moment(createdAt).isBefore(launchedAt), 
                                 formattedDate: moment(launchedAt).add(543, 'year').format('D MMMM YYYY') 
                             })
                         }).catch(() => {
                             this.handleShouldOpen({ 
                                 email, 
                                 isOldCustomer: false, 
                                 formattedDate: '' 
                             })
                         })
 
                         return
                     } else {
                         this.handleShouldOpen({ 
                             email, 
                             isOldCustomer: moment(shopMetadata.createdAt).isBefore(shopMetadata.launchedAt), 
                             formattedDate: moment(shopMetadata.launchedAt).add(543, 'year').format('D MMMM YYYY') 
                         })
                     }
                 }
             },
             handleSubmitVerification() {
                 const url = `${process.env.VUE_APP_MEMBER_SERVICE_API}/verification`
 
                 this.loading = true
 
                 this.$http.post(url, {
                     email: this.email,
                     platform: 'POPSHOP',
                     scope: ['email', 'phone'],
                     consent: ['wallet_popshop'],
                     callbackUrl: `${window.location.origin}/callback/wallet-verification`
                 }).then(res => {
                     if (res.data.status) {
                         this.message = 'ระบบส่งข้อมูลแล้ว กรุณาตรวจสอบที่ Email'
                         this.isSuccess = true
                     } else {
                         this.message = this.mapErrorMessage(res.data.message)
                         this.isSuccess = false
                     }
                 }).catch(err => {
                     this.message = this.mapErrorMessage(err.response.data.message)
                     this.isSuccess = false
                 }).finally(() => {
                     this.loading = false
                 })
             },
             mapErrorMessage(key) {
                 switch (key) {
                     case 'member_not_found':
                         return 'ไม่พบข้อมูลสมาชิก'
                     default:
                         return key
                 }
             }
         }
     }
 </script>